import { useEffect, useMemo } from 'react';
import Suspenseloader from '../../common/splash/suspenseloader';

import { useAuthContext } from 'src/auth/AuthProvider';
import { useHistory } from 'react-router-dom';
import { deleteCookie, getCookie } from 'src/utils/cookie';
import { CookieredirectUrl } from 'src/utils/constants';
import { useRouter } from 'src/shared/hooks';
import {
  BROADCAST_CHANNEL_AUTH_ID,
  broadcastChannelReload,
} from 'src/utils/helpers/broadcast-channel';

export function LoginFromCookie() {
  const { handleStoredLogin } = useAuthContext();
  const { push } = useHistory();
  const { history } = useRouter();
const bcAuth = useMemo(() => new BroadcastChannel(BROADCAST_CHANNEL_AUTH_ID), []);

  useEffect(() => {
    const login = async () => {
      await handleStoredLogin(true);
      broadcastChannelReload(bcAuth);
      const redirectURL = getCookie(CookieredirectUrl);
      if (redirectURL) {
        history.push(redirectURL);
        deleteCookie(CookieredirectUrl);
      } else push('/');
    };

    login();
  }, [handleStoredLogin, push, history, bcAuth]);

  return <Suspenseloader />;
}
